import { DownloadAppBanner } from "@ui/blocks/DownloadAppBanner";
import { useLocale } from "@/shared/hooks/useLocale";

import { useScreenName } from "@features/tracking/hooks/useScreenName";
import { usePageTracking } from "@features/tracking/hooks/usePageTracking";
import { ScreenName } from "@motain/web-shared-hub/features";

export const ErrorPage = () => {
  const { t } = useLocale();
  useScreenName(ScreenName.Error);
  usePageTracking();

  return (
    <DownloadAppBanner
      title={t("500_ERROR_TITLE")}
      message={t("500_ERROR_MESSAGE")}
      getAppText={t("GET_THE_APP")}
    />
  );
};
